import React from "react";
import { arrayOf, bool, func, number, object, shape, string } from "prop-types";
import { isMobile } from "../../helpers";
import TextFieldGroup from "../TextFieldGroup";

const range = (n) => [...Array(n).keys()];

const Table = ({ tableKey, value, setField, tableDetails }) => {
  const rows = tableDetails.rows || range(tableDetails.unnamedRows);

  const setTableField = (row, column) => (e) => {
    const newValue = {
      ...value,
      [row]: {
        ...value[row],
        [column]: e.target.value,
      },
    };
    setField(tableKey, newValue);
  };

  return isMobile ? (
    rows.map((row, rowIndex) =>
      tableDetails.collapsableOnMobile ? (
        <div className="mb-1">
          <a
            className="btn btn-light btn-block"
            data-toggle="collapse"
            href={`#${tableKey}-${rowIndex}`}
          >
            {row}
          </a>
          <div
            className="collapse border rounded-bottom p-1 text-justify"
            id={`${tableKey}-${rowIndex}`}
          >
            {tableDetails.columns.map((column, columnIndex) => (
              <div key={column} className="form-group">
                <label
                  htmlFor={`${tableKey}-${rowIndex}-${columnIndex}`}
                  className="mb-hf"
                >
                  {column}
                </label>
                <TextFieldGroup
                  inputId={`${tableKey}-${rowIndex}-${columnIndex}`}
                  classes="register_field"
                  value={value[row][column] || ""}
                  onChange={setTableField(row, column)}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        tableDetails.columns.map((column) => (
          <div key={column} className="form-group">
            <label htmlFor={`${row}.${column}`} className="mb-hf">{`${column} ${
              rowIndex + 1
            }`}</label>
            <TextFieldGroup
              inputId={`${row}.${column}`}
              classes="register_field"
              value={value[row][column] || ""}
              onChange={setTableField(row, column)}
            />
          </div>
        ))
      )
    )
  ) : (
    <table className="table table-bordered" id={tableKey}>
      <thead>
        <tr>
          {tableDetails.rows && <th />}
          {tableDetails.columns.map((column) => (
            <th scope="col" key={column}>
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={row}>
            {tableDetails.rows && <td>{row}</td>}
            {tableDetails.columns.map((column, columnIndex) => (
              <td key={column} className="p-0" style={{ height: 49 }}>
                <TextFieldGroup
                  inputId={`${tableKey}-${rowIndex}-${columnIndex}`}
                  classes="register_field h-100"
                  value={value[row][column] || ""}
                  onChange={setTableField(row, column)}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

Table.propTypes = {
  tableKey: string.isRequired,
  value: object.isRequired,
  setField: func.isRequired,
  tableDetails: shape({
    rows: arrayOf(string),
    columns: arrayOf(string),
    unnamedRows: number,
    collapsableOnMobile: bool,
  }).isRequired,
};

export default Table;
